export const REQUEST_AUTH_PING = 'REQUEST_AUTH_PING';
export const RECEIVE_AUTH_PING = 'RECEIVE_AUTH_PING';
export const REQUEST_ACTIVATION_STATUS = 'REQUEST_ACTIVATION_STATUS';
export const RECEIVE_ACTIVATION_STATUS = 'RECEIVE_ACTIVATION_STATUS';
export const REQUEST_ACTIVATE = 'REQUEST_ACTIVATE';
export const RECEIVE_ACTIVATE = 'RECEIVE_ACTIVATE';
export const REQUEST_CATALOGS = 'REQUEST_CATALOGS';
export const RECEIVE_CATALOGS = 'RECEIVE_CATALOGS';
export const RECEIVE_UPDATED_CATALOG = 'RECEIVE_UPDATED_CATALOG';
export const REQUEST_ASSETS = 'REQUEST_ASSETS';
export const RECEIVE_ASSETS = 'RECEIVE_ASSETS';
export const REQUEST_ASSET = 'REQUEST_ASSET';
export const RECEIVE_ASSET = 'RECEIVE_ASSET';
export const REQUEST_ASSET_TYPES = 'REQUEST_ASSET_TYPES';
export const RECEIVE_ASSET_TYPES = 'RECEIVE_ASSET_TYPES';
export const REQUEST_ATTRIBUTES = 'REQUEST_ATTRIBUTES';
export const RECEIVE_ATTRIBUTES = 'RECEIVE_ATTRIBUTES';
export const REQUEST_SAVE_ATTRIBUTES = 'REQUEST_SAVE_ATTRIBUTES';
export const RECEIVE_SAVE_ATTRIBUTES = 'RECEIVE_SAVE_ATTRIBUTES';
export const UPDATE_ATTRIBUTE_FILTER = 'UPDATE_ATTRIBUTE_FILTER';
export const REQUEST_ASSET_ATTRIBUTES = 'REQUEST_ASSET_ATTRIBUTES';
export const RECEIVE_ASSET_ATTRIBUTES = 'RECEIVE_ASSET_ATTRIBUTES';
export const REQUEST_ASSET_ATTRIBUTE_VALUES = 'REQUEST_ASSET_ATTRIBUTE_VALUES';
export const RECEIVE_ASSET_ATTRIBUTE_VALUES = 'RECEIVE_ASSET_ATTRIBUTE_VALUES';
export const UPDATE_PROFILE_TAG = 'UPDATE_PROFILE_TAG';
export const DELETE_PROFILE_TAG = 'DELETE_PROFILE_TAG';
export const REQUEST_PROFILE = 'REQUEST_PROFILE';
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE';
export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
export const RECEIVE_UPDATE_PROFILE = 'RECEIVE_UPDATE_PROFILE';
export const REQUEST_UPLOAD_PROFILE = 'REQUEST_UPLOAD_PROFILE';
export const RECEIVE_UPLOAD_PROFILE = 'RECEIVE_UPLOAD_PROFILE';
export const REQUEST_ASSET_SUMMARY = 'REQUEST_ASSET_SUMMARY';
export const RECEIVE_ASSET_SUMMARY = 'RECEIVE_ASSET_SUMMARY';
export const REQUEST_ASSET_DISTRIBUTION = 'REQUEST_ASSET_DISTRIBUTION';
export const RECEIVE_ASSET_DISTRIBUTION = 'RECEIVE_ASSET_DISTRIBUTION';
export const REQUEST_RANDOM_ASSET = 'REQUEST_RANDOM_ASSET';
export const RECEIVE_RANDOM_ASSET = 'RECEIVE_RANDOM_ASSET';
export const REQUEST_SAVE_ASSET = 'REQUEST_SAVE_ASSET';
export const RECEIVE_SAVE_ASSET = 'RECEIVE_SAVE_ASSET';
export const CLEAR_ASSET_SAVE_CONTEXT = 'CLEAR_ASSET_SAVE_CONTEXT';
export const REQUEST_SAVE_ASSET_CLASS = 'REQUEST_SAVE_ASSET_CLASS';
export const RECEIVE_SAVE_ASSET_CLASS = 'RECEIVE_SAVE_ASSET_CLASS';
export const UPDATE_ASSET_DISTRIBUTION_FILTER =
  'UPDATE_ASSET_DISTRIBUTION_FILTER';
export const UPDATE_ASSET_FILTER = 'UPDATE_ASSET_FILTER';
export const CLEAR_ASSET_SEARCH_CONTEXT = 'CLEAR_ASSET_SEARCH_CONTEXT';
export const REQUEST_BLOCK_DATA = 'REQUEST_BLOCK_DATA';
export const RECEIVE_BLOCK_DATA = 'RECEIVE_BLOCK_DATA';
export const REQUEST_USER_DATA = 'REQUEST_USER_DATA';
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';
export const REQUEST_BLOCKS = 'REQUEST_BLOCKS';
export const RECEIVE_BLOCKS = 'RECEIVE_BLOCKS';
export const REQUEST_BLOCK_DISTRIBUTION = 'REQUEST_BLOCK_DISTRIBUTION';
export const RECEIVE_BLOCK_DISTRIBUTION = 'RECEIVE_BLOCK_DISTRIBUTION';
export const REQUEST_MESSAGE_BLOCKS = 'REQUEST_MESSAGE_BLOCKS';
export const RECEIVE_MESSAGE_BLOCKS = 'RECEIVE_MESSAGE_BLOCKS';
export const REQUEST_SAVE_BLOCK_DATA = 'REQUEST_SAVE_BLOCK_DATA';
export const RECEIVE_SAVE_BLOCK_DATA = 'RECEIVE_SAVE_BLOCK_DATA';
export const REQUEST_SAVE_BLOCK_SDK_DATA = 'REQUEST_SAVE_BLOCK_SDK_DATA';
export const RECEIVE_SAVE_BLOCK_SDK_DATA = 'RECEIVE_SAVE_BLOCK_SDK_DATA';
export const REQUEST_SET_CONTENT = 'REQUEST_SET_CONTENT';
export const RECEIVE_SET_CONTENT = 'RECEIVE_SET_CONTENT';
export const REQUEST_CREATE_CATALOG = 'REQUEST_CREATE_CATALOG';
export const RECEIVE_CREATE_CATALOG = 'RECEIVE_CREATE_CATALOG';
export const CLEAR_CONTENT_BUILDER_SEARCH = 'CLEAR_CONTENT_BUILDER_SEARCH';
export const REQUEST_CONTENT_BUILDER_SEARCH = 'REQUEST_CONTENT_BUILDER_SEARCH';
export const RECEIVE_CONTENT_BUILDER_SEARCH = 'RECEIVE_CONTENT_BUILDER_SEARCH';
export const REQUEST_CONTENT_BUILDER_PREVIEW =
  'REQUEST_CONTENT_BUILDER_PREVIEW';
export const RECEIVE_CONTENT_BUILDER_PREVIEW =
  'RECEIVE_CONTENT_BUILDER_PREVIEW';
export const CLEAR_DATA_EXTENSION_STATUS = 'CLEAR_DATA_EXTENSION_STATUS';
export const REQUEST_DATA_EXTENSIONS = 'REQUEST_DATA_EXTENSIONS';
export const RECEIVE_DATA_EXTENSIONS = 'RECEIVE_DATA_EXTENSIONS';
export const REQUEST_DATA_EXTENSION_COLUMNS = 'REQUEST_DATA_EXTENSION_COLUMNS';
export const RECEIVE_DATA_EXTENSION_COLUMNS = 'RECEIVE_DATA_EXTENSION_COLUMNS';
export const REQUEST_CREATE_DATA_EXTENSION_IMPORT =
  'REQUEST_CREATE_DATA_EXTENSION_IMPORT';
export const RECEIVE_CREATE_DATA_EXTENSION_IMPORT =
  'RECEIVE_CREATE_DATA_EXTENSION_IMPORT';
export const REQUEST_IMPORTS = 'REQUEST_IMPORTS';
export const RECEIVE_IMPORTS = 'RECEIVE_IMPORTS';
export const RECEIVE_UPDATED_IMPORT = 'RECEIVE_UPDATED_IMPORT';
export const REQUEST_IMPORT_CONFIGURATION = 'REQUEST_IMPORT_CONFIGURATION';
export const RECEIVE_IMPORT_CONFIGURATION = 'RECEIVE_IMPORT_CONFIGURATION';
export const REQUEST_FTP_IMPORT_CONFIGURATION =
  'REQUEST_FTP_IMPORT_CONFIGURATION';
export const RECEIVE_FTP_IMPORT_CONFIGURATION =
  'RECEIVE_FTP_IMPORT_CONFIGURATION';
export const REVERT_CLASSIFIER_RULES = 'REVERT_CLASSIFIER_RULES';
export const REVERT_EXCLUSION_RULES = 'REVERT_EXCLUSION_RULES';
export const REVERT_FATIGUE_RULES = 'REVERT_FATIGUE_RULES';
export const REVERT_VARIETY_RULES = 'REVERT_VARIETY_RULES';
export const REQUEST_GET_RULES = 'REQUEST_GET_RULES';
export const RECEIVE_GET_RULES = 'RECEIVE_GET_RULES';
export const REQUEST_SAVE_RULES = 'REQUEST_SAVE_RULES';
export const RECEIVE_SAVE_RULES = 'RECEIVE_SAVE_RULES';
export const REQUEST_SAVE_CONTINGENCY = 'REQUEST_SAVE_CONTINGENCY';
export const RECEIVE_SAVE_CONTINGENCY = 'RECEIVE_SAVE_CONTINGENCY';
export const REQUEST_JOBS = 'REQUEST_JOBS';
export const RECEIVE_JOBS = 'RECEIVE_JOBS';
export const REQUEST_JOB_DETAILS = 'REQUEST_JOB_DETAILS';
export const RECEIVE_JOB_DETAILS = 'RECEIVE_JOB_DETAILS';
export const REQUEST_PERFORMANCE = 'REQUEST_PERFORMANCE';
export const RECEIVE_PERFORMANCE = 'RECEIVE_PERFORMANCE';
export const UPDATE_RULES = 'UPDATE_RULES';
export const MODIFY_ANALYTICS_FILTER = 'MODIFY_ANALYTICS_FILTER';
export const MODIFY_ATTRIBUTE_FILTERS = 'MODIFY_ATTRIBUTE_FILTERS';
export const MODIFY_ATTRIBUTE_CHART = 'MODIFY_ATTRIBUTE_CHART';
export const REQUEST_FALLBACK_ASSETS = 'REQUEST_FALLBACK_ASSETS';
export const RECEIVE_FALLBACK_ASSETS = 'RECEIVE_FALLBACK_ASSETS';
export const REQUEST_SAVE_FALLBACK_ASSET = 'REQUEST_SAVE_FALLBACK_ASSET';
export const RECEIVE_SAVE_FALLBACK_ASSET = 'RECEIVE_SAVE_FALLBACK_ASSET';
export const REQUEST_REPORTS = 'REQUEST_REPORTS';
export const RECEIVE_REPORTS = 'RECEIVE_REPORTS';
export const MODIFY_REPORTS_FILTER = 'MODIFY_REPORTS_FILTER';
export const REQUEST_CREATE_TAGS = 'REQUEST_CREATE_TAGS';
export const RECEIVE_CREATE_TAGS = 'RECEIVE_CREATE_TAGS';
export const CLEAR_TAGS = 'CLEAR_TAGS';
export const ANALYTICS_COLORS = [
  '#3296ed',
  '#77b9f2',
  '#9d53f2',
  '#c398f5',
  '#26aba4',
  '#4ed4cd',
  '#f7a452',
  '#faca98',
  '#f2536d',
  '#f598a7'
];
export const REQUEST_FLAGS = 'REQUEST_FLAGS';
export const RECEIVE_FLAGS = 'RECEIVE_FLAGS';
export const REQUEST_READONLY = 'REQUEST_READONLY';
export const RECEIVE_READONLY = 'RECEIVE_READONLY';
export const REQUEST_SELECTIONS = 'REQUEST_SELECTIONS';
export const RECEIVE_SELECTIONS = 'RECEIVE_SELECTIONS';
export const REQUEST_REMOVE_SELECTIONS = 'REQUEST_REMOVE_SELECTIONS';
export const RECEIVE_REMOVE_SELECTIONS = 'RECEIVE_REMOVE_SELECTIONS';
export const VIEW_SELECTION = 'VIEW_SELECTION';
export const REQUEST_PROFILE_AUDIT = 'REQUEST_PROFILE_AUDIT';
export const RECEIVE_PROFILE_AUDIT = 'RECEIVE_PROFILE_AUDIT';
export const REQUEST_EDIT_PROFILE_STATUS = 'REQUEST_EDIT_PROFILE_STATUS';
export const RECEIVE_EDIT_PROFILE_STATUS = 'RECEIVE_EDIT_PROFILE_STATUS';
export const FLAGS = [
  'parent_child',
  'subject_line',
  'demo',
  'ftp_import',
  'center_block_in_table',
  'fallback_rules',
  'dont_relax_fatigue',
  'gdpr',
  'right_to_left',
  'number_rules'
];
